import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
// import { useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import { alpha } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
// import CmtImage from "../../../../@coremat/CmtImage";
import IntlMessages from "src/@jumbo/utils/IntlMessages";
// import { AuthMethods } from "src/services/auth";
import ContentLoader from "src/@jumbo/components/ContentLoader";
import Typography from "@material-ui/core/Typography";
// import { CurrentAuthMethod } from "src/@jumbo/constants/AppConstants";
import { forgotPassword } from "src/api/auth";
import AuthWrapper from "./AuthWrapper";
import InputAdornment from "@material-ui/core/InputAdornment";
import EmailIcon from '@material-ui/icons/Email';

const useStyles = makeStyles((theme) => ({
	authThumb: {
		backgroundColor: alpha(theme.palette.primary.main, 0.12),
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: 20,
		[theme.breakpoints.up("md")]: {
			width: "50%",
			order: 2,
		},
	},
	authContent: {
		padding: 30,
		[theme.breakpoints.up("md")]: {
			order: 1,
			width: (props) => (props.variant === "default" ? "50%" : "100%"),
		},
		[theme.breakpoints.up("xl")]: {
			padding: 50,
		},
	},
	titleRoot: {
		marginBottom: 14,
		color: theme.palette.text.primary,
	},
	textFieldRoot: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: alpha(theme.palette.common.dark, 0.12),
		},
	},
}));
//variant = 'default', 'standard', 'bgColor'
const ForgotPassword = ({ variant = "default", wrapperVariant = "default" }) => {
	const [email, setEmail] = useState("");
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(null);
	const { tenant } = useSelector(({ auth }) => auth);
	// const dispatch = useDispatch();
	const classes = useStyles({ variant });

	const onSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError(null);
		try {
			await forgotPassword({ email, tenantId: tenant.id });
			setSuccess("Reset link has been sent to your email. Don't forget to check the spam folder too.");
		} catch (err) {
			console.error("Forgot password link sending failed", err);
			setError(err.message || "Unable to send reset link");
		} finally {
			setLoading(false);
		}
	};

	return (
		<AuthWrapper variant={wrapperVariant}>
			<Box display="flex" flexDirection="column" alignItems="flex-start" mt={4} style={{ padding: 20 }}>
				<Typography component="h1" variant="h5" align="left" className={classes.titleRoot} style={{ fontWeight: 600, fontSize: 22, color: "#446475", marginBottom: 24, width: '100%' }}>
					Forgot Password?
				</Typography>
				<Typography align="left" style={{ marginBottom: 24, color: "#666", width: '100%' }}>
					Please enter the email address associated with your account to receive a verification code for password reset.
			</Typography>
			{error && <div className="text-red-700 text-center">{error}</div>}
			{success && <div className="text-green-600 text-center">{success}</div>}
				<form onSubmit={onSubmit} style={{ width: '100%', maxWidth: 550 }}>
				<Box mb={5}>
						<Typography variant="body2" style={{ fontWeight: 500, marginBottom: 1 }}>
							Email <span style={{ color: 'red' }}>*</span>
						</Typography>
					<TextField
							placeholder="Enter your email"
						fullWidth
						onChange={(event) => setEmail(event.target.value)}
						defaultValue={email}
						margin="normal"
						variant="outlined"
						className={classes.textFieldRoot}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<EmailIcon color="action" />
									</InputAdornment>
								),
								autoComplete: "email",
							}}
					/>
				</Box>
				<Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
					<Box component="p" fontSize={{ xs: 12, sm: 16 }}>
						<NavLink to="/login">Back to login</NavLink>
					</Box>
					<Button type="submit" variant="contained" color="primary">
						Email Reset Link {loading && <CircularProgress color="inherit" size={"1rem"} className="ml-2" />}
					</Button>
				</Box>

				<Box>
					<Typography>
						Don&apos;t remember your email?
						<Box component="span" ml={2}>
							<NavLink to="/contact-us">
								<IntlMessages id="appModule.contactSupport" />
							</NavLink>
						</Box>
					</Typography>
				</Box>
			</form>
			<ContentLoader />
			</Box>
		</AuthWrapper>
	);
};

export default ForgotPassword;
